import { useTranslation } from 'react-i18next'
import { LanguageSwitcher } from '../i18n/components/LanguageSwitcher'
import {
  DevCredentialsHint,
  EmailField,
  ErrorAlert,
  LoginHeader,
  PasswordField,
  SubmitButton,
} from './login-page/login-page.parts'
import { useLoginForm } from './login-page/use-login-form'

export function LoginPage(): React.ReactElement {
  const { t } = useTranslation('auth')
  const form = useLoginForm(t)

  return (
    <div className="flex min-h-screen items-center justify-center bg-stone-50 px-4 dark:bg-stone-950">
      <div className="w-full max-w-md">
        <LoginHeader t={t} />
        <div className="rounded-xl border border-stone-200 bg-white p-8 shadow-sm dark:border-stone-800 dark:bg-stone-900">
          <form
            onSubmit={(e) => {
              void form.handleSubmit(e)
            }}
            className="space-y-6"
          >
            {form.error && <ErrorAlert message={form.error} />}
            <EmailField
              value={form.email}
              onChange={form.setEmail}
              disabled={form.isLoading}
              t={t}
            />
            <PasswordField
              value={form.password}
              onChange={form.setPassword}
              showPassword={form.showPassword}
              onToggleShow={form.toggleShowPassword}
              disabled={form.isLoading}
              t={t}
            />
            <SubmitButton isLoading={form.isLoading} t={t} />
          </form>
        </div>
        <div className="mt-4 flex justify-center">
          <LanguageSwitcher variant="standalone" />
        </div>
        <DevCredentialsHint />
      </div>
    </div>
  )
}
